module.exports = "<app-navbar></app-navbar>"